// extracted by mini-css-extract-plugin
module.exports = {"TablePagination":"style_TablePagination__3HVRN","button":"style_button__36FDm"};